import { createAsyncThunk } from "@reduxjs/toolkit";
import { CustomAction } from "../../store/customAction";
import { Api } from "../..";
import {
  IAgentLoginRequestBody,
  IAgentLoginResponse,
  IAgentLogoutRequestBody,
} from "../../models/agent/agentAuth/agentAuth";
import {
  API_GET_AGENT_LOGOUT,
  API_POST_AGENT_LOGIN,
  API_POST_SENT_OTP,
  API_POST_VALIDATE_OTP,
} from "../../Apis/ApiEndPoints";
import {
  ISendOtpRequestParmas,
  IVerifyOtpRequestParams,
} from "../../models/user/userAuth/userAuth";

export const agentLogin = createAsyncThunk(
  "agentAuth/agentLogin",
  async (requestBody: IAgentLoginRequestBody, { dispatch }) => {
    const response: IAgentLoginResponse = await CustomAction(
      Api.post(API_POST_AGENT_LOGIN, requestBody),
      dispatch,
      "agentAuth/agentLogin"
    );

    return response;
  }
);

export const agentLogout = createAsyncThunk(
  "agentAuth/agentLogout",
  async (requestBody: IAgentLogoutRequestBody, { dispatch }) => {
    await CustomAction(
      Api.get(API_GET_AGENT_LOGOUT, { params: requestBody }),
      dispatch,
      "agentAuth/agentLogout"
    );
  }
);

export const sendOtp = createAsyncThunk(
  "userAuth/sendOtp",
  async (requestParams: ISendOtpRequestParmas, { dispatch }) => {
    await CustomAction(
      Api.post(API_POST_SENT_OTP, requestParams),
      dispatch,
      "userAuth/sendOtp"
    );
  }
);

export const verifyOtp = createAsyncThunk(
  "userAuth/verifyOtp",
  async (requestParams: IVerifyOtpRequestParams, { dispatch }) => {
    const response = await CustomAction(
      Api.post(API_POST_VALIDATE_OTP, requestParams),
      dispatch,
      "userAuth/verifyOtp"
    );
    return response;
  }
);
